import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../Common/Navigation/Header/Header";
import { COMPOSE_HEADER_TEXT, DOCUMENT_HEADER_TEXT } from "../../../Core/Common/Constants";
import ComposeWizard from "src/components/Compose/ComposeWizard";
import { ApplicationState } from "src/store";
import { checkIfPermissionIsAllowed } from "src/helper/HelperFunctions";
import { ResourceIdLocators } from "src/helper/ResourceIdLocators";
import FeatureDisabled from "src/components/Common/Navigation/FeatureDisabled";
import { PageDisabledTypes } from "src/Core/ViewModels/User/UserViewModel";
import { getDocumentCategoriesDropdown } from "src/actionCreators/documentCategoryActionCreator";

const ComposeLayout: React.FC = () => {
    const [showCompose, setshowCompose] = React.useState(false);
    const isMounted = React.useRef(false);
    const allowedPermissions = useSelector((state: ApplicationState) => state.rbacState.resourceList);
    const [isAccessAllowed, setIsAccessAllowed] = React.useState(false);
    const dispatch = useDispatch();
    React.useEffect(() => {
        // Check whether page permission is allowed
        setIsAccessAllowed(checkIfPermissionIsAllowed(allowedPermissions, ResourceIdLocators.Global.NewMessageBtn));
        dispatch(getDocumentCategoriesDropdown());
    }, [allowedPermissions]);
    const getHeaderTitle = () => {
        if (!showCompose) {
            return `${DOCUMENT_HEADER_TEXT}`;
        } else {
            return `${COMPOSE_HEADER_TEXT}`;
        }
    };

    const handleOnContinueClick = () => {
        setshowCompose(true);
    };

    const handleOnBackClick = () => {
        setshowCompose(false);
        isMounted.current = true;
    };

    return isAccessAllowed ? (
        <div className="app-container">
            <Header title={getHeaderTitle()} />
            <div className="app-wrapper-with-padding">
                <ComposeWizard
                    showCompose={showCompose}
                    handleOnContinueClick={handleOnContinueClick}
                    handleOnBackClick={handleOnBackClick}
                    isMounted={isMounted.current}
                />
            </div>
        </div>
    ) : (
        <FeatureDisabled type={PageDisabledTypes.PageAccessDenied} />
    );
};

export default ComposeLayout;
